import React, { useState, useEffect } from "react";
import { useStateContext } from "../../context/ContextProvider";

const deadlines = [
  "January 3 2025 23:59:59 GMT+0400",
  "January 6 2025 23:59:59 GMT+0400",
  "January 9 2025 23:59:59 GMT+0400",
  "January 12 2025 23:59:59 GMT+0400",
  "January 15 2025 23:59:59 GMT+0400",
  "January 18 2025 23:59:59 GMT+0400",
  "January 21 2025 23:59:59 GMT+0400",
  "January 24 2025 23:59:59 GMT+0400",
  "January 27 2025 23:59:59 GMT+0400",
  "January 30 2025 23:59:59 GMT+0400",
  "February 2 2025 23:59:59 GMT+0400",
  "February 5 2025 23:59:59 GMT+0400",
  "February 8 2025 23:59:59 GMT+0400",
  "February 11 2025 23:59:59 GMT+0400",
  "February 14 2025 23:59:59 GMT+0400",
  "February 17 2025 23:59:59 GMT+0400",
  "February 20 2025 23:59:59 GMT+0400",
  "February 23 2025 23:59:59 GMT+0400",
  "February 26 2025 23:59:59 GMT+0400",
  "March 1 2025 23:59:59 GMT+0400",
];

const Countdown = () => {
  const {
    langCode,
    isLangRTL,
    i18n
  } = useStateContext();

  const [selectedDeadline, setSelectedDeadline] = useState("");
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Find the next deadline
  useEffect(() => {
    const today = new Date();
    let nextDeadline = deadlines.find(
      (date) => new Date(date).getTime() > today.getTime()
    );

    if (!nextDeadline) {
      const fallbackDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
      nextDeadline = fallbackDate.toISOString();
    }

    setSelectedDeadline(new Date(nextDeadline));
  }, []);

  // Update countdown every second
  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!selectedDeadline) return;

      const total = new Date(selectedDeadline).getTime() - new Date().getTime();
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((total / (1000 * 60)) % 60);
      const seconds = Math.floor((total / 1000) % 60);

      setTimeRemaining({ days, hours, minutes, seconds });

      if (total <= 0) {
        clearInterval(intervalId);
      }
    };

    const intervalId = setInterval(calculateTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [selectedDeadline]);

  const getCountdownText = () => {
    if (langCode === "ar") {
      return "الفرصة لفترة محدودة";
    }
    return "LIMITED TIME OFFER";
  };

  return (
    <div
      className={`flex justify-start w-full`}
      style={{
        zIndex: 10,
      }}
    >
      <div className="countdown-overlay">
      <div className="countdown-text">{getCountdownText()}</div>
        <div className="countdown-clock">
          <div className="clock">
            <div className="clock__item">
              <span className="days">{timeRemaining.days}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className="clock__item">
              <span className="hours">{timeRemaining.hours}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className="clock__item">
              <span className="minutes">{timeRemaining.minutes}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className="clock__item">
              <span className="seconds">{timeRemaining.seconds}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
